export const space = {
  mainMarginLg: '3rem',
  mainMarginSm: '1rem',
};

// Padding for App layout
export const PX_APP_LAYOUT = [4, 6, 6, 6, 6];
export const PY_APP_LAYOUT = [4, 6, 6, 6, 6];

export const P_PAGE_LAYOUT = [4];

export const GAP_PAGE_LAYOUT = [4];
export const GAP_PAGE_SECTION = [20];
export const Z_INDEX = {
  SECONDARY_NAV: 1,
  TOP_NAV: 2,
  FOOTER: 2,
  POPOVER: 3,
};

export const FORM_SPACE = {
  FORM_COLUMN_GAP: ['1rem'],
  FORM_SUB_COLUMN_GAP: ['.5rem'],
  FORM_LABEL_GAP: ['.5rem'],
  FORM_TOOLTIP_GAP: ['.25rem'],
};
